import _asyncToGenerator from "/var/www/yestrademarks/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/var/www/yestrademarks/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/var/www/yestrademarks/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/var/www/yestrademarks/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/yestrademarks/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Particles_engine;
import { calcPositionFromSize, getRangeMax, getRangeMin, getRangeValue, randomInRange, setRangeValue } from "../Utils/NumberUtils";
import { InteractionManager } from "./Utils/InteractionManager";
import { Particle } from "./Particle";
import { ParticlesOptions } from "../Options/Classes/Particles/ParticlesOptions";
import { Point } from "./Utils/Point";
import { QuadTree } from "./Utils/QuadTree";
import { Rectangle } from "./Utils/Rectangle";
export var Particles = /*#__PURE__*/function (_redraw, _update, _draw) {
  function Particles(engine, container) {
    _classCallCheck(this, Particles);
    this.container = container;
    _Particles_engine.set(this, void 0);
    __classPrivateFieldSet(this, _Particles_engine, engine, "f");
    this.nextId = 0;
    this.array = [];
    this.zArray = [];
    this.limit = 0;
    this.needsSort = false;
    this.lastZIndex = 0;
    this.freqs = {
      links: new Map(),
      triangles: new Map()
    };
    this.interactionManager = new InteractionManager(__classPrivateFieldGet(this, _Particles_engine, "f"), container);
    var canvasSize = this.container.canvas.size;
    this.linksColors = new Map();
    this.quadTree = new QuadTree(new Rectangle(-canvasSize.width / 4, -canvasSize.height / 4, canvasSize.width * 3 / 2, canvasSize.height * 3 / 2), 4);
    this.movers = __classPrivateFieldGet(this, _Particles_engine, "f").plugins.getMovers(container, true);
    this.updaters = __classPrivateFieldGet(this, _Particles_engine, "f").plugins.getUpdaters(container, true);
  }
  _createClass(Particles, [{
    key: "count",
    get: function get() {
      return this.array.length;
    }
  }, {
    key: "init",
    value: function init() {
      var _a;
      var container = this.container,
        options = container.actualOptions;
      this.lastZIndex = 0;
      this.needsSort = false;
      this.freqs.links = new Map();
      this.freqs.triangles = new Map();
      var handled = false;
      this.updaters = __classPrivateFieldGet(this, _Particles_engine, "f").plugins.getUpdaters(container, true);
      this.interactionManager.init();
      var _iterator = _createForOfIteratorHelper(container.plugins),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            plugin = _step$value[1];
          if (plugin.particlesInitialization !== undefined) {
            handled = plugin.particlesInitialization();
          }
          if (handled) {
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.addManualParticles();
      if (!handled) {
        for (var group in options.particles.groups) {
          var groupOptions = options.particles.groups[group];
          for (var i = this.count, j = 0; j < ((_a = groupOptions.number) === null || _a === void 0 ? void 0 : _a.value) && i < options.particles.number.value; i++, j++) {
            this.addParticle(undefined, groupOptions, group);
          }
        }
        for (var _i = this.count; _i < options.particles.number.value; _i++) {
          this.addParticle();
        }
      }
      container.pathGenerator.init(container);
    }
  }, {
    key: "redraw",
    value: function redraw() {
      return (_redraw = _redraw || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.clear();
              this.init();
              _context.next = 4;
              return this.draw({
                value: 0,
                factor: 0
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }))).apply(this, arguments);
    }
  }, {
    key: "removeAt",
    value: function removeAt(index) {
      var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var group = arguments.length > 2 ? arguments[2] : undefined;
      var override = arguments.length > 3 ? arguments[3] : undefined;
      if (!(index >= 0 && index <= this.count)) {
        return;
      }
      var deleted = 0;
      for (var i = index; deleted < quantity && i < this.count; i++) {
        var particle = this.array[i];
        if (!particle || particle.group !== group) {
          continue;
        }
        particle.destroy(override);
        this.array.splice(i--, 1);
        var zIdx = this.zArray.indexOf(particle);
        this.zArray.splice(zIdx, 1);
        deleted++;
      }
    }
  }, {
    key: "remove",
    value: function remove(particle, group, override) {
      this.removeAt(this.array.indexOf(particle), undefined, group, override);
    }
  }, {
    key: "update",
    value: function update(_x) {
      return (_update = _update || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(delta) {
        var container, particlesToDelete, _iterator2, _step2, _step2$value, plugin, _iterator3, _step3, _particle, resizeFactor, _iterator5, _step5, _step5$value, _plugin, _iterator6, _step6, mover, _i2, _particlesToDelete, particle, _iterator4, _step4, _particle2, _iterator7, _step7, updater;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              container = this.container, particlesToDelete = [];
              container.pathGenerator.update();
              _iterator2 = _createForOfIteratorHelper(container.plugins);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  _step2$value = _slicedToArray(_step2.value, 2), plugin = _step2$value[1];
                  if (plugin.update !== undefined) {
                    plugin.update(delta);
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _iterator3 = _createForOfIteratorHelper(this.array);
              _context2.prev = 5;
              _iterator3.s();
            case 7:
              if ((_step3 = _iterator3.n()).done) {
                _context2.next = 39;
                break;
              }
              _particle = _step3.value;
              resizeFactor = container.canvas.resizeFactor;
              if (resizeFactor && !_particle.ignoresResizeRatio) {
                _particle.position.x *= resizeFactor.width;
                _particle.position.y *= resizeFactor.height;
              }
              _particle.ignoresResizeRatio = false;
              _particle.bubble.inRange = false;
              _iterator5 = _createForOfIteratorHelper(this.container.plugins);
              _context2.prev = 14;
              _iterator5.s();
            case 16:
              if ((_step5 = _iterator5.n()).done) {
                _context2.next = 23;
                break;
              }
              _step5$value = _slicedToArray(_step5.value, 2), _plugin = _step5$value[1];
              if (!_particle.destroyed) {
                _context2.next = 20;
                break;
              }
              return _context2.abrupt("break", 23);
            case 20:
              if (_plugin.particleUpdate) {
                _plugin.particleUpdate(_particle, delta);
              }
            case 21:
              _context2.next = 16;
              break;
            case 23:
              _context2.next = 28;
              break;
            case 25:
              _context2.prev = 25;
              _context2.t0 = _context2["catch"](14);
              _iterator5.e(_context2.t0);
            case 28:
              _context2.prev = 28;
              _iterator5.f();
              return _context2.finish(28);
            case 31:
              _iterator6 = _createForOfIteratorHelper(this.movers);
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  mover = _step6.value;
                  if (mover.isEnabled(_particle)) {
                    mover.move(_particle, delta);
                  }
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
              if (!_particle.destroyed) {
                _context2.next = 36;
                break;
              }
              particlesToDelete.push(_particle);
              return _context2.abrupt("continue", 37);
            case 36:
              this.quadTree.insert(new Point(_particle.getPosition(), _particle));
            case 37:
              _context2.next = 7;
              break;
            case 39:
              _context2.next = 44;
              break;
            case 41:
              _context2.prev = 41;
              _context2.t1 = _context2["catch"](5);
              _iterator3.e(_context2.t1);
            case 44:
              _context2.prev = 44;
              _iterator3.f();
              return _context2.finish(44);
            case 47:
              for (_i2 = 0, _particlesToDelete = particlesToDelete; _i2 < _particlesToDelete.length; _i2++) {
                particle = _particlesToDelete[_i2];
                this.remove(particle);
              }
              _context2.next = 50;
              return this.interactionManager.externalInteract(delta);
            case 50:
              _iterator4 = _createForOfIteratorHelper(container.particles.array);
              _context2.prev = 51;
              _iterator4.s();
            case 53:
              if ((_step4 = _iterator4.n()).done) {
                _context2.next = 62;
                break;
              }
              _particle2 = _step4.value;
              _iterator7 = _createForOfIteratorHelper(this.updaters);
              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  updater = _step7.value;
                  updater.update(_particle2, delta);
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
              if (!(!_particle2.destroyed && !_particle2.spawning)) {
                _context2.next = 60;
                break;
              }
              _context2.next = 60;
              return this.interactionManager.particlesInteract(_particle2, delta);
            case 60:
              _context2.next = 53;
              break;
            case 62:
              _context2.next = 67;
              break;
            case 64:
              _context2.prev = 64;
              _context2.t2 = _context2["catch"](51);
              _iterator4.e(_context2.t2);
            case 67:
              _context2.prev = 67;
              _iterator4.f();
              return _context2.finish(67);
            case 70:
              delete container.canvas.resizeFactor;
            case 71:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[5, 41, 44, 47], [14, 25, 28, 31], [51, 64, 67, 70]]);
      }))).apply(this, arguments);
    }
  }, {
    key: "draw",
    value: function draw(_x2) {
      return (_draw = _draw || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(delta) {
        var container, canvasSize, _iterator8, _step8, _step8$value, plugin, _iterator9, _step9, p;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              container = this.container, canvasSize = this.container.canvas.size;
              this.quadTree = new QuadTree(new Rectangle(-canvasSize.width / 4, -canvasSize.height / 4, canvasSize.width * 3 / 2, canvasSize.height * 3 / 2), 4);
              container.canvas.clear();
              _context3.next = 5;
              return this.update(delta);
            case 5:
              if (this.needsSort) {
                this.zArray.sort(function (a, b) {
                  return b.position.z - a.position.z || a.id - b.id;
                });
                this.lastZIndex = this.zArray[this.zArray.length - 1].position.z;
                this.needsSort = false;
              }
              _iterator8 = _createForOfIteratorHelper(container.plugins);
              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  _step8$value = _slicedToArray(_step8.value, 2), plugin = _step8$value[1];
                  container.canvas.drawPlugin(plugin, delta);
                }
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }
              _iterator9 = _createForOfIteratorHelper(this.zArray);
              try {
                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                  p = _step9.value;
                  p.draw(delta);
                }
              } catch (err) {
                _iterator9.e(err);
              } finally {
                _iterator9.f();
              }
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }))).apply(this, arguments);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.array = [];
      this.zArray = [];
    }
  }, {
    key: "push",
    value: function push(nb, mouse, overrideOptions, group) {
      this.pushing = true;
      for (var i = 0; i < nb; i++) {
        this.addParticle(mouse === null || mouse === void 0 ? void 0 : mouse.position, overrideOptions, group);
      }
      this.pushing = false;
    }
  }, {
    key: "addParticle",
    value: function addParticle(position, overrideOptions, group) {
      var container = this.container,
        options = container.actualOptions,
        limit = options.particles.number.limit * container.density;
      if (limit > 0) {
        var countToRemove = this.count + 1 - limit;
        if (countToRemove > 0) {
          this.removeQuantity(countToRemove);
        }
      }
      return this.pushParticle(position, overrideOptions, group);
    }
  }, {
    key: "addSplitParticle",
    value: function addSplitParticle(parent) {
      var splitOptions = parent.options.destroy.split,
        options = new ParticlesOptions();
      options.load(parent.options);
      var factor = getRangeValue(splitOptions.factor.value);
      options.color.load({
        value: {
          hsl: parent.getFillColor()
        }
      });
      if (typeof options.size.value === "number") {
        options.size.value /= factor;
      } else {
        options.size.value.min /= factor;
        options.size.value.max /= factor;
      }
      options.load(splitOptions.particles);
      var offset = splitOptions.sizeOffset ? setRangeValue(-parent.size.value, parent.size.value) : 0,
        position = {
          x: parent.position.x + randomInRange(offset),
          y: parent.position.y + randomInRange(offset)
        };
      return this.pushParticle(position, options, parent.group, function (particle) {
        if (particle.size.value < 0.5) {
          return false;
        }
        particle.velocity.length = randomInRange(setRangeValue(parent.velocity.length, particle.velocity.length));
        particle.splitCount = parent.splitCount + 1;
        particle.unbreakable = true;
        setTimeout(function () {
          particle.unbreakable = false;
        }, 500);
        return true;
      });
    }
  }, {
    key: "removeQuantity",
    value: function removeQuantity(quantity, group) {
      this.removeAt(0, quantity, group);
    }
  }, {
    key: "getLinkFrequency",
    value: function getLinkFrequency(p1, p2) {
      var range = setRangeValue(p1.id, p2.id),
        key = "".concat(getRangeMin(range), "_").concat(getRangeMax(range));
      var res = this.freqs.links.get(key);
      if (res === undefined) {
        res = Math.random();
        this.freqs.links.set(key, res);
      }
      return res;
    }
  }, {
    key: "getTriangleFrequency",
    value: function getTriangleFrequency(p1, p2, p3) {
      var _ref = [p1.id, p2.id, p3.id],
        id1 = _ref[0],
        id2 = _ref[1],
        id3 = _ref[2];
      if (id1 > id2) {
        var _ref2 = [id1, id2];
        id2 = _ref2[0];
        id1 = _ref2[1];
      }
      if (id2 > id3) {
        var _ref3 = [id2, id3];
        id3 = _ref3[0];
        id2 = _ref3[1];
      }
      if (id1 > id3) {
        var _ref4 = [id1, id3];
        id3 = _ref4[0];
        id1 = _ref4[1];
      }
      var key = "".concat(id1, "_").concat(id2, "_").concat(id3);
      var res = this.freqs.triangles.get(key);
      if (res === undefined) {
        res = Math.random();
        this.freqs.triangles.set(key, res);
      }
      return res;
    }
  }, {
    key: "addManualParticles",
    value: function addManualParticles() {
      var container = this.container,
        options = container.actualOptions;
      var _iterator10 = _createForOfIteratorHelper(options.manualParticles),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var particle = _step10.value;
          this.addParticle(calcPositionFromSize({
            size: container.canvas.size,
            position: particle.position
          }), particle.options);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
  }, {
    key: "setDensity",
    value: function setDensity() {
      var options = this.container.actualOptions;
      for (var group in options.particles.groups) {
        this.applyDensity(options.particles.groups[group], 0, group);
      }
      this.applyDensity(options.particles, options.manualParticles.length);
    }
  }, {
    key: "handleClickMode",
    value: function handleClickMode(mode) {
      this.interactionManager.handleClickMode(mode);
    }
  }, {
    key: "applyDensity",
    value: function applyDensity(options, manualCount, group) {
      var _a;
      if (!((_a = options.number.density) === null || _a === void 0 ? void 0 : _a.enable)) {
        return;
      }
      var numberOptions = options.number,
        densityFactor = this.initDensityFactor(numberOptions.density),
        optParticlesNumber = numberOptions.value,
        optParticlesLimit = numberOptions.limit > 0 ? numberOptions.limit : optParticlesNumber,
        particlesNumber = Math.min(optParticlesNumber, optParticlesLimit) * densityFactor + manualCount,
        particlesCount = Math.min(this.count, this.array.filter(function (t) {
          return t.group === group;
        }).length);
      this.limit = numberOptions.limit * densityFactor;
      if (particlesCount < particlesNumber) {
        this.push(Math.abs(particlesNumber - particlesCount), undefined, options, group);
      } else if (particlesCount > particlesNumber) {
        this.removeQuantity(particlesCount - particlesNumber, group);
      }
    }
  }, {
    key: "initDensityFactor",
    value: function initDensityFactor(densityOptions) {
      var container = this.container;
      if (!container.canvas.element || !densityOptions.enable) {
        return 1;
      }
      var canvas = container.canvas.element,
        pxRatio = container.retina.pixelRatio;
      return canvas.width * canvas.height / (densityOptions.factor * Math.pow(pxRatio, 2) * densityOptions.area);
    }
  }, {
    key: "pushParticle",
    value: function pushParticle(position, overrideOptions, group, initializer) {
      try {
        var particle = new Particle(__classPrivateFieldGet(this, _Particles_engine, "f"), this.nextId, this.container, position, overrideOptions, group);
        var canAdd = true;
        if (initializer) {
          canAdd = initializer(particle);
        }
        if (!canAdd) {
          return;
        }
        this.array.push(particle);
        this.zArray.push(particle);
        this.nextId++;
        return particle;
      } catch (e) {
        console.warn("error adding particle: ".concat(e));
        return;
      }
    }
  }]);
  return Particles;
}();
_Particles_engine = new WeakMap();